import { useIsSSR } from '@infinex/ui-utils/react-dom';

import { breakpoints } from './breakpoints';

/**
 * Whether the screen width is less than the "md" breakpoint. Useful for
 * conditional rendering based on the screen width.
 *
 * @note The screen width is different from the viewport width. The screen
 * width is the width of the entire screen, while the viewport width is the width
 * of the browser window.
 */
export function useIsSmallScreen() {
  const isSSR = useIsSSR();

  if (isSSR || typeof window === 'undefined') {
    return false;
  }

  // improve the responsive design experience in playroom
  if (insideIframe()) {
    return window.innerWidth < breakpoints.md;
  }

  return window.screen.width < breakpoints.md;
}

function insideIframe() {
  return window.self !== window.top;
}
